<template>
  <div>
    <!-- 一个介绍 -->
    <div class="white-card self-introduction">
      <h3>为什么会有这个网站?</h3>
      <p>
        首先主要目的是为了拥有一个属于自己的网站，把自己的所学用到这个网站上面来，校验自己的不足和学习一些新的东西，让自己能有一个真正的拿得出手的作品。
      </p>
      <p>
        在这个网站上可以拿来记录一些个人的心得笔记之类的。也放置一些自己觉得不错的别人的随笔，彼此借鉴交流和学习。促进自己的一个发展。
      </p>
      <p>希望这些随笔记录的东西能够帮得到一些需要的人。</p>
    </div>

    <!-- 今日数据 -->
    <div class="today-wrap">
      <div class="white-card today-card">
        <h3>{{ todayStats.今日访问量 || 0 }}</h3>
        <h6>今日访问</h6>
      </div>
      <div class="white-card today-card">
        <h3>{{ todayStats.今日阅读量 || 0 }}</h3>
        <h6>今日阅读</h6>
      </div>
      <div class="white-card today-card">
        <h3>{{ todayStats.今日评论数 || 0 }}</h3>
        <h6>今日评论</h6>
      </div>
    </div>

    <!-- 最近随笔 -->
    <div class="blog-wrap" v-if="currentTop.length">
      <h3 class="class-title"><i class="iconfont icon-shuji2"></i>最新随笔</h3>

      <div class="card-wrap">
        <blog-card v-for="blog in currentTop" :key="blog.blogId" :blog="blog">
        </blog-card>
      </div>
    </div>

    <div class="blog-wrap" v-if="readTop.length">
      <h3 class="class-title">
        <i class="iconfont icon-tuijian1"></i>博主推荐
      </h3>
      <div class="card-wrap">
        <blog-card v-for="blog in readTop" :key="blog.blogId" :blog="blog">
        </blog-card>
      </div>
    </div>

    <template v-if="!currentTop.length && !currentTop.length">
      <div class="img-wrap">
        <img src="@/assets/images/no-data.png" alt="" />
        <div class="no-data">暂无数据</div>
      </div>
    </template>

    <div class="footer-wrap">
      <p> Copyright © 2022 <a href="http://www.itsunn.cn">itsunn</a> All Rights Reserved. </p>
      <a href="https://beian.miit.gov.cn" target="_blank"> 粤ICP备2022149801号-2 </a>
    </div>
  </div>
</template>

<script>
import data from "./index.js";
export default data;
</script>

<style scoped src="@/assets/css/index.css"></style>